/**
 * @module builder
 */

import type { BulkEditDetails, BulkEditItem } from '../..'
/**
 * return bulkEditItems that use selected product
 */
export function getProductLocations(product: string, bulkDetails: BulkEditDetails): BulkEditItem[] {
  const productLocations = bulkDetails.editItems.map((item: BulkEditItem) => {
    //  Need to filter these BulkEditItem to the given uniqueProduct
    if (item.substrate) {
      // Handle substrates with no product
      if (item.substrate.products === null || item.substrate.products.length === 0) {
        return item
      }
      item.substrate.products.forEach((prod) => {
        if (prod?.label === String(product)) {
          return item
        }
      })
    }

    // lineItems
    if (item.products) {
      let used = false
      item?.products.forEach((prod) => {
        if (prod?.label === String(product)) {
          used = true
        } else if (!prod && product === 'No Material Selected') {
          used = true
        }
      })
      if (used) {
        return item
      }
    }
  })

  return productLocations.filter(Boolean)
}
